import { connect } from 'react-redux';
import SwimlaneTopBar from './TopBar';
import { resetCreatePto } from '../../../store/createOrder';
import { resetFilters, updateSearchPtoFilter } from '../../../store/searchFilters';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  resetCreatePto,
  resetFilters,
  updateSearchPtoFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(SwimlaneTopBar);
